export function getExcelData(data) {
  // param: data list of: [
  // {
  //     "createdDate": 1674688441671,
  //     "modifiedDate": 1674688531165,
  //     "createdBy": "mauricio@pksystems.com.ec",
  //     "modifiedBy": "mauricio@pksystems.com.ec",
  //     "id": 133102,
  //     "code": "666",
  //     "name": "AAMEGALEXINA",
  //     "presentation": "MM",
  //     "manufacturer": "MM",
  //     "activeMolecularCompound": "MM",
  //     "unitContent": "MM",
  //     "administration": "MM",
  //     "category": {
  //         "id": 23566,
  //         "name": "ACIDIFICANTES",
  //         "abbreviation": "ACD",
  //         "catalogTypeId": 6
  //     },
  //     "categoryId": 23566,
  //     "sector": {
  //         "id": 12,
  //         "name": "AVICULTURA",
  //         "abbreviation": "AVI",
  //         "catalogTypeId": 2
  //     },
  //     "sectorId": 12,
  //     "subSector": {
  //         "id": 16,
  //         "name": "ADITIVO",
  //         "abbreviation": "ADI",
  //         "catalogTypeId": 3
  //     },
  //     "subSectorId": 16,
  //     "group": {
  //         "id": 58,
  //         "name": "ACIDIFICANTES",
  //         "abbreviation": "ACI",
  //         "catalogTypeId": 1
  //     },
  //     "groupId": 58,
  //     "form": {
  //         "id": 206,
  //         "name": "AEROSOL",
  //         "abbreviation": "AER",
  //         "catalogTypeId": 7
  //     },
  //     "formId": 206,
  //     "company": {
  //         "id": 1,
  //         "code": "AEN",
  //         "name": "AENSA",
  //         "representative": "Francisco Troya",
  //         "telephone": "026009999"
  //     },
  //     "companyId": 1,
  //     "active": false
  // },
  //  ]
  let rows = [];
  data.forEach((elem, index) => {
    var _known = {
      Nro: index + 1,
      Codigo: elem.code,
      Nombre: elem.name,
      Fabricante: elem.manufacturer,
      Presentacion: elem.presentation,
      Administracion: elem.administration,
      unitContent: elem.unitContent,
      Forma: "form" in elem ? elem.form.name : "",
      Sector: "sector" in elem ? elem.sector.name : "",
      SubSector: "subSector" in elem ? elem.subSector.name : "",
      Grupo: "group" in elem ? elem.group.name : "",
      Categoria: "category" in elem ? elem.category.name : "",
    };
    rows.push(_known);
  });
  return rows;
}
